import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import { Button, colors } from "@material-ui/core";
import CheckboxItem, { useStylesAcc } from "./CheckBoxComponent";
import DiscountPermissions from "./discount-permissions";
const formData = [
  { name: "Automatic_Insert", label: "الإدخال (أوتماتيك)", visible: true },

  {
    name: "UpdatePurchDate",
    label: "السماح بتعديل تاريخ فاتورة الشراء",
    visible: true,
  },
  {
    name: "UpdatePurchPrice",
    label: "السماح بتعديل سعر الشراء ",
    visible: true,
  },
  {
    name: "purchVatUpdate",
    label: "السماح بتعديل الضريبه عند الشراء",
    visible: true,
  },
  {
    name: "use_price_without_vat",
    label: "استخدام السعر لا يشمل الضريبة في فاتورة الشراء",
    visible: true,
  },
  {
    name: "Purch_than_Less_Purch_Item",
    label: "السماح بالشراء بسعر اقل من  سعر الشراء في بيانات الاصناف",
    visible: true,
  },
  {
    name: "SaleInMinus",
    label: "السماح بإرجاع المشتريات بدون وجود كمية بالمخزن",
    visible: true,
  },
  {
    name: "Cust_PurchPrice",
    label: "اعتماد اخر سعر شراء للمورد لكل صنف",
    visible: false,
  },
  {
    name: "Hide_Purch_Bill_Price",
    label: "اخفاء سعر البيع",
    visible: true,
  },
  {
    name: "Purch_out_goods",
    label: "عرض طباعة تصريح خروج بضاعة لمرتجع مشتريات",
    visible: true,
  },
 
  { 
    name: "allow_discount", 
    label: "السماح بالخصم ", 
    visible: true 
  },
  // {
  //   name: "inv_post_unlock",
  //   label: "السماح بتعديل او حذف فاتورة بعد الترحيل",
  //   visible: true,
  // },
  {
    name: "IS_Delete",
    label: "السماح بحذف الفاتورة بعد الترحيل",
    visible: true,
  },
  {
    name: "IS_Update",
    label: "السماح بتعديل الفاتورة  بعد الترحيل",
    visible: true,
  },
  {
    name: "NoRepeatItem",
    label: "الفاء تجميع الاصناف",
    visible: true,
  },
  {
    name: "Cust_SalePrice",
    label: "اعتماد اخر سعر شراء للمورد لكل صنف",
    visible: true,
  },
  {
    name: "return_same_invoice_date",
    label: "ارجاع الفاتورة بنفس تاريخ فاتورة الشراء",
    visible: true,
  },
  {
    name: "allow_return_Without_bill",
    label: "السماح بالارجاع بدون رقم فاتورة",
    visible: true,
  },
  {
    name: "use_barcode_reader",
    label: "استخدام قارئ الباركود",
    visible: true,
  },
];

export default function PurchPermissions(props) {
  const { onChange, object, update, sub } = props;

  const classes = useStylesAcc();

  return (
    <div className={classes.root}>
      <Accordion expanded={true}>
        {/* <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          style={{ background: "#d9dcf078" }}
        >
          <Typography className={classes.heading}>إعدادات المشتريات</Typography>
        </AccordionSummary> */}


        <AccordionDetails >
          <Grid item container spacing={1}>
            {formData
              ?.filter((d) => d.visible)
              ?.map((item) => {
                // console.log(object);
                return (
                  <Grid xs={6}>
                    <CheckboxItem
                      value={object[item.name] ?? null}
                      name={item.name}
                      label={item.label}
                      onChange={onChange}
                    />
                  </Grid>
                );
              })}
          </Grid>
        </AccordionDetails>

        <AccordionDetails>
          {" "}
          <Typography> {"إعدادات الخصومات المشتريات"}  
          
            </Typography>{" "}    
             
                   
        </AccordionDetails>

        <AccordionDetails style={{backgroundColor:colors.grey[50]}}>
          { object?.allow_discount ? <DiscountPermissions {...props} />: 
          <Typography variant="h5" style={{textAlign:"center"}}> 
          {/* <br />   */}
          {/* {"\n this settings don't work if past discount allowed attribute doesn't enables"} */}
          {"\n تاكد من تفعيل السماح بالخصم حتى يتم تفعيل الخيارات"}

            </Typography> }
        </AccordionDetails>
        <Divider className={classes.divider} />
        <AccordionDetails className={classes.subTitle}>
          {" "}
          <Typography>
            {" "}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              disabled={props.submitting}
              onClick={update}
            >
              {"حفظ التعديلات"}
            </Button>
          </Typography>{" "}
        </AccordionDetails>
      </Accordion>
      <Swipeable />
    </div>
  );
}
